import "./ProductAccordion.css";
import { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";

const ProductAccordion = ({ product }) => {
  const [active, setActive] = useState(null);

  // Helper function to generate default specifications based on saree category
  const getDynamicSpecs = (product) => {
    if (!product) return [{ label: "Fabric", value: "Handloom Silk / Cotton" }, { label: "Craft", value: "Traditional Weave" }];

    const cat = (product.category || product.displayCategory || "").toLowerCase();

    if (cat.includes("ilkal")) {
      return [
        { label: "Fabric", value: cat.includes("silk") ? "Pure Silk" : "Pure Cotton" },
        { label: "Craft", value: "Handloom Ilkal Weave (Chikki Paras Border / Tope Teni Pallu)" },
        { label: "Origin", value: "Ilkal, Karnataka" },
      ];
    }

    if (cat.includes("maheshwari")) {
      return [
        { label: "Fabric", value: "Cotton Silk / Tissue" },
        { label: "Craft", value: "Handloom Maheshwari (Reversible Border & Zari Patterns)" },
        { label: "Origin", value: "Maheshwar, Madhya Pradesh" },
      ];
    }

    if (cat.includes("chanderi")) {
      return [
        { label: "Fabric", value: "Cotton Silk / Pattu Soft Silk" },
        { label: "Craft", value: "Handloom Chanderi (Zari Motifs & Sheer Texture)" },
        { label: "Origin", value: "Chanderi, Madhya Pradesh" },
      ];
    }

    if (cat.includes("paithani")) {
      return [
        { label: "Fabric", value: cat.includes("cotton") ? "Cotton Silk" : "Pure Mulberry Silk" },
        { label: "Craft", value: "Handwoven Yeola Paithani (Gold Zari & Peacock Motifs)" },
        { label: "Origin", value: "Yeola / Maharashtra" },
      ];
    }

    // Default fallback
    return [
      { label: "Fabric", value: "Authentic Handloom Fabric" },
      { label: "Craft", value: "Traditional Artisan Weaving" },
    ];
  };

  // Uses custom specifications array if provided in the product object, else generates dynamic specs
  const specsToDisplay = product?.specifications || getDynamicSpecs(product);

  const accordionData = [
    {
      title: "DESCRIPTION",
      type: "description",
    },
    {
      title: "SHIPPING & RETURN",
      content:
        "Free shipping across India on all orders. Orders are dispatched within 24–48 hours and delivered within 4–7 business days.",
    },
    {
      title: "RETURN / EXCHANGE POLICY",
      content:
        "We offer an easy 7-day exchange policy for unused items with original tags intact. Please reach out to our support team for exchange assistance.",
    },
  ];

  return (
    <section className="accordion-section">
      <div className="container">
        <div className="accordion">
          {accordionData.map((item, index) => {
            const isOpen = active === index;

            return (
              <div className="accordion-item" key={index}>
                <button
                  type="button"
                  className="accordion-title"
                  onClick={() => setActive(isOpen ? null : index)}
                >
                  <h3>{item.title}</h3>
                  {isOpen ? <FaMinus /> : <FaPlus />}
                </button>

                <div className={`accordion-content ${isOpen ? "show" : ""}`}>
                  {item.type === "description" ? (
                    <div className="description-wrapper">
                      <h4 className="desc-product-name">{product?.name}</h4>
                      <p className="desc-intro">
                        {product?.longDescription || product?.description}
                      </p>
                      <ul className="desc-specs-list">
                        {specsToDisplay.map((spec, i) => (
                          <li key={i}>
                            <strong>{spec.label}:</strong>{" "}
                            {spec.value ? spec.value : ""}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    <p>{item.content}</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProductAccordion;